import * as Sentry from '@sentry/react'
import { init } from '@sentry/react'
import CryptoJS from 'crypto-js'
import { getConfig } from 'config'

const config = await getConfig()

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY

function encryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString()
}

export function configureSentry() {
  init({
    dsn: SENTRY_DSN,
    environment: config.sentryEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.3,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event) {
      // Encrypt event data before sending it to Sentry
      if (event && event.user && event.user.id) {
        event.user.id = encryptData(event.user.id)
      }
      return event
    },
  })
}
